(function () {
    const navigationContainer = document.querySelector('.site-header__element__navigation');
    const newNavigation = document.querySelector('.site-header__element__navigation .navigation');
    const newNavigationUl = document.querySelector('.site-header__element__navigation .navigation .navigation-first-tier');
    const mobileNavigationToggle = document.querySelector('.mobile-navigation-toggle');

    if(mobileNavigationToggle){
        mobileNavigationToggle.addEventListener('click', () => {
            const isOpen = navigationContainer.classList.contains('open') && mobileNavigationToggle.classList.contains('open');
    
            if (isOpen) {
                navigationContainer.classList.remove('open');
                if(mobileNavigationToggle){
                    mobileNavigationToggle.classList.remove('open');
                } 
                if (newNavigation) {
                    newNavigation.style.removeProperty('height');
                }
            } else {
                navigationContainer.classList.add('open');
                mobileNavigationToggle.classList.add('open');
                const newNavigationUlHeight = newNavigationUl.getBoundingClientRect().height;
                if (newNavigation) {
                    newNavigation.style.height = `${newNavigationUlHeight}px`;
                }
            }
        });
    }

    

    const mobileTierToggles = document.querySelectorAll('.site-header__element__navigation .navigation .navigation-first-tier .has-dropdown .mobile-tier-toggle');

    mobileTierToggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault(); // Evita que el enlace se active
            const isOpen = toggle.classList.contains('open');

            // Elimina la clase 'open' de todos los elementos y ajusta la altura
            mobileTierToggles.forEach(t => {
                t.classList.remove('open');
                const secondTierWrapper = t.closest('.has-dropdown').querySelector('.navigation-second-tier-wrapper');
                if (secondTierWrapper) {
                    secondTierWrapper.classList.remove('open');
                    secondTierWrapper.style.removeProperty('height');
                }
            });

            // Si el elemento no estaba abierto, añade la clase 'open' y ajusta la altura
            if (!isOpen) {
                toggle.classList.add('open');
                const secondTierWrapper = toggle.closest('.has-dropdown').querySelector('.navigation-second-tier-wrapper');
                const secondTier = secondTierWrapper.querySelector('.navigation-second-tier');
                const secondTierHeight = secondTier.getBoundingClientRect().height;

                secondTierWrapper.classList.add('open');
                secondTierWrapper.style.height = `${secondTierHeight}px`;
                if (newNavigation) {
                    newNavigation.style.height = `${parseFloat(newNavigation.style.height) + secondTierHeight}px`;
                }
            } else {
                toggle.classList.remove('open');
                const secondTierWrapper = toggle.closest('.has-dropdown').querySelector('.navigation-second-tier-wrapper');
                const secondTier = secondTierWrapper.querySelector('.navigation-second-tier');
                const secondTierHeight = secondTier.getBoundingClientRect().height;

                secondTierWrapper.style.removeProperty('height');
                if (newNavigation) {
                    newNavigation.style.height = `${parseFloat(newNavigation.style.height) - secondTierHeight}px`;
                }
            }
        });
    });

    // Media query to remove height properties and 'open' class for desktop view
    const mediaQuery = window.matchMedia('(min-width: 1020px)');
    function handleMediaChange(e) {
        if (e.matches) {
            if (newNavigation) {
                newNavigation.style.removeProperty('height');
            }
            if(navigationContainer){
                navigationContainer.classList.remove('open');
            }
            if(mobileNavigationToggle){
                mobileNavigationToggle.classList.remove('open');
            }
            mobileTierToggles.forEach(toggle => {
                toggle.classList.remove('open');
                const secondTierWrapper = toggle.closest('.has-dropdown').querySelector('.navigation-second-tier-wrapper');
                if (secondTierWrapper) {
                    secondTierWrapper.classList.remove('open');
                    secondTierWrapper.style.removeProperty('height');
                }
            });
        }
    }
    mediaQuery.addListener(handleMediaChange);
    handleMediaChange(mediaQuery);
})();